import { IAppState, TActions } from '../../common/state';
import { jq } from '../../json_query';

export const IBSCentersChangedActionType = 'filters/bs_centers/BS_CENTERS_CHANGED';

export interface IBSCentersChangedAction {
  type: 'filters/bs_centers/BS_CENTERS_CHANGED';
  bsCenterId: number;
  text: string;
}

export function newbuildingHouseReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'newbuilding-house') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).unsetNewbuildingHouse(action.tag.value),
          },
        };
      }

      return state;

    case 'filters/tags/ALL_TAGS_REMOVED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jq(state.filters.jsonQuery).unsetNewbuildingHouses(),
        },
      };

    default:
      return state;
  }
}
